import {Dispatch, SetStateAction} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../components/button';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  description: string;
  buttonText?: string; // Optional button label, default "متوجه شدم"
  onConfirm?: () => void; // Optional callback when button is clicked
}

const ErrorBottomSheet = ({
  isOpen,
  setIsOpen,
  title,
  description,
  buttonText = 'متوجه شدم',
  onConfirm,
}: IProps) => {
  const handleClose = () => {
    setIsOpen(false);
    onConfirm?.();
  };

  return (
    <BottomSheet
      open={isOpen}
      onDismiss={handleClose}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="flex w-full flex-col p-6 relative">
        <i
          className="icon-nameClose-remove absolute top-6 left-6 text-2xl text-gray-500"
          onClick={handleClose}
        />
        <div className="flex flex-col gap-2 justify-center items-center">
          <i className="icon-nameremove-circle  text-4xl text-red-500" />
          <p className="text-center text-xl font-semibold text-gray-950">
            {title}
          </p>
        </div>

        <p className="text-right text-lg text-gray-700">{description}</p>

        <div className="flex ">
          <Button className="w-full" onClick={handleClose}>
            {buttonText}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ErrorBottomSheet;
